/* global ShopgateProductDetailsCore */
import DebugConsole from '../debug/debug-console';

const logger = DebugConsole();

/**
 * Plugin connects product history helper with product script.
 *
 * @param {SGProductDetailsCore} core productScript core object
 * @returns {Object}
 */
function recentlyViewedProducts(core) {
  /**
   * Called when the core has collected data to display a new product
   * @param  {string} callType The type of the function call (products.ui or products.data)
   */
  function onUpdateProduct() {
    const shopNumber = core.getCoreOptions().shopNumber;
    const product = core.getParentProduct().product;

    $.sgHelpers.itemHistory.addEntry(product, shopNumber);
  }

  const hooks = {
    vendor: 'Shopgate',
    name: 'ShopgateRecentlyViewed',
    type: ['products.data'],
    onUpdateProduct,
  };

  return hooks;
}

if (
    typeof ShopgateProductDetailsCore === 'object'
    && typeof ShopgateProductDetailsCore.registerPlugin === 'function'
  ) {
  ShopgateProductDetailsCore.registerPlugin(recentlyViewedProducts);
} else {
  logger.error('No instance of "ShopgateProductDetailsCore" found');
}



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-recently-viewed.js